import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/auth-context';
import RouteErrorBoundary from './dashboard/ui/RouteErrorBoundary';
import App from './App';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element #root not found in index.html');
}

// The data router lets an active clinical editor hold browser Back/Forward
// until both existing writers have resolved. App retains its established
// route table; this root only supplies the history blocker capability.
const router = createBrowserRouter([{
  path: '*',
  element: (
    <AuthProvider>
      <RouteErrorBoundary>
        <App />
      </RouteErrorBoundary>
    </AuthProvider>
  ),
}]);

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
